var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{attrs:{"autocomplete":"false"},on:{"submit":function($event){$event.preventDefault();}}},[_c('vue-form-generator',{attrs:{"schema":_vm.schema,"model":_vm.datas,"options":_vm.formOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }